import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

import style from './index.module.scss';

@Component({ name: 'SourceOfIncome' })
export default class SourceOfIncome extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private incomeSource: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.incomeSource = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.incomeSource) {
      this.incomeSource = val;
    }
  }

  public onValidator(): boolean {
    if (this.incomeSource === undefined || this.incomeSource === null) {
      this.errorMsg = '请选择收入来源';
      return false;
    }

    return true;
  }

  private onChangeIncomeSource(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.SourceOfIncome}>
        <Field
          v-model={this.incomeSource}
          onChange={() => this.onChangeIncomeSource(this.incomeSource)}
          sub={true}
          label="收入来源"
          type="select"
          dictApi={DictApi.getIncomeSource}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
